/*
 * Product Grid Carousel
 * Lightweight carousel for product cards on collection pages.
 * Uses native CSS scroll-snap with JS for navigation controls.
 */
(function () {
  function initCarousel(container) {
    var track = container.querySelector('[data-carousel-track]');
    var productImage = container.closest('[data-product-image]');
    if (!track || !productImage) return;

    var nav = productImage.querySelector('[data-carousel-nav]');
    if (!nav) return;

    var dots = nav.querySelectorAll('[data-carousel-dot]');
    var prevBtn = nav.querySelector('[data-carousel-prev]');
    var nextBtn = nav.querySelector('[data-carousel-next]');
    var slides = track.querySelectorAll('[data-carousel-slide]');
    var slideCount = slides.length;
    var currentIndex = 0;

    if (slideCount <= 1) return;

    function updateState(index) {
      currentIndex = index;

      // Update dots
      for (var i = 0; i < dots.length; i++) {
        if (i === currentIndex) {
          dots[i].classList.add('is-active');
        } else {
          dots[i].classList.remove('is-active');
        }
      }

      // Update arrow disabled state
      if (prevBtn) {
        if (currentIndex === 0) {
          prevBtn.setAttribute('disabled', '');
        } else {
          prevBtn.removeAttribute('disabled');
        }
      }
      if (nextBtn) {
        if (currentIndex === slideCount - 1) {
          nextBtn.setAttribute('disabled', '');
        } else {
          nextBtn.removeAttribute('disabled');
        }
      }
    }

    function scrollToSlide(index) {
      if (index < 0 || index >= slideCount) return;
      var slideWidth = track.offsetWidth;
      track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    }

    // Detect current slide from scroll position
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var slideWidth = track.offsetWidth;
        if (slideWidth === 0) return;
        var newIndex = Math.round(track.scrollLeft / slideWidth);
        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slideCount) {
          updateState(newIndex);
        }
      }, 50);
    }, { passive: true });

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex > 0) {
          scrollToSlide(currentIndex - 1);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex < slideCount - 1) {
          scrollToSlide(currentIndex + 1);
        }
      });
    }

    // Dot clicks
    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dotIndex = parseInt(this.getAttribute('data-carousel-dot'), 10);
        if (!isNaN(dotIndex)) {
          scrollToSlide(dotIndex);
        }
      });
    }

    // Prevent carousel interactions from triggering the product link
    nav.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Set initial state
    updateState(0);
  }

  function initAllCarousels() {
    var carousels = document.querySelectorAll('[data-product-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      // Skip already-initialized carousels
      if (!carousels[i].hasAttribute('data-carousel-initialized')) {
        carousels[i].setAttribute('data-carousel-initialized', 'true');
        initCarousel(carousels[i]);
      }
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Re-initialize when Shopify re-renders sections (e.g., after AJAX pagination/filtering)
  document.addEventListener('shopify:section:load', initAllCarousels);

  // Also watch for dynamically added product cards (infinite scroll, AJAX filter)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var hasNewCarousels = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var node = mutations[i].addedNodes[j];
            if (node.nodeType === 1 && (node.querySelector('[data-product-carousel]') || node.hasAttribute('data-product-carousel'))) {
              hasNewCarousels = true;
              break;
            }
          }
        }
        if (hasNewCarousels) break;
      }
      if (hasNewCarousels) {
        initAllCarousels();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
